export default __webpack_public_path__ + "static/media/Ballroll_00186.a9400734.png";